import { format, parseISO } from "date-fns";
import {
  Campaigns,
  CountCampaigns,
  InsightQueryWpResponse,
  PaidCampaigns,
  RequestCampaignsParams,
} from "../types/campaigns";
import { ENV } from "../utils/constants";
import api from "./api";

export const getPaidCampaigns = async (
  data: RequestCampaignsParams
): Promise<PaidCampaigns[]> => {
  const params = {
    start_date: format(data.startDate, "yyyy-MM-dd"),
    end_date: format(data.endDate, "yyyy-MM-dd"),
  };

  const response = await api.get(`/ads-manager-${ENV}/ads`, {
    params,
  });

  return response.data?.content;
};

export const getCampaigns = async (
  data: RequestCampaignsParams
): Promise<any /*Campaigns[]*/> => {
  async function req_ads(): Promise<Campaigns[]> {
    return api
      .get(`https://api.datasales.info/ads-manager-${ENV}/ads`, {})
      .then((response) => {
        let campaignsAds = response.data.content.map((ad: any) => ({
          id_campanha: ad.campaign_id,
          whatsapp_url: ad.image,
          nome_campanha: ad.name,
          tipo_campanha: "ADS",
          ...ad,
        }));
        if (data.name) {
          campaignsAds = campaignsAds.filter((item: any) =>
            item.nome_campanha.toLowerCase().includes(data.name)
          );
        }
        campaignsAds = campaignsAds.filter(
          (item: any) =>
            format(parseISO(item.created_time), "yyyy-MM-dd") >=
              format(data.startDate, "yyyy-MM-dd") &&
            format(parseISO(item.created_time), "yyyy-MM-dd") <=
              format(data.endDate, "yyyy-MM-dd")
        );
        return campaignsAds;
      })
      .catch((err) => {
        console.log("GET ADS ERROR");
        console.log(err);
        return [];
      });
  }

  async function req_campaigns() {
    const params = {
      data_inicio: format(data.startDate, "yyyy-MM-dd"),
      data_fim: format(data.endDate, "yyyy-MM-dd"),
      page: data.page,
      ...(data.type && { tipo_campanha: data.type.toLocaleUpperCase() }),
      ...(data?.name && { nome_campanha: data.name }),
    };

    return api
      .get(`/advertising-dashboard-${ENV}/goals/listcampaigns`, { params })
      .then((response: any) => {
        return response.data.content.campaigns;
      })
      .catch((err) => {
        console.log("GET CAMPAIGNS ERROR");
        console.log(err);
        return [];
      });
  }

  const allRequests: any = [];
  if (!data?.type && data.page === 0) {
    allRequests.push(
      ...(await Promise.allSettled([req_campaigns(), req_ads()]))
    );
  } else if ((!data?.type && data.page > 0) || data?.type !== "ads") {
    allRequests.push(...(await Promise.allSettled([req_campaigns()])));
  } else if (data?.type === "ads") {
    allRequests.push(...(await Promise.allSettled([req_ads()])));
  }

  function compare(a: any, b: any) {
    if (a.data_inicio_campanha < b.data_inicio_campanha) {
      return 1;
    }
    if (a.data_inicio_campanha > b.data_inicio_campanha) {
      return -1;
    }
    return 0;
  }

  if (allRequests.length === 2) {
    const campaigns = allRequests[0].value;
    const ads = allRequests[1].value;
    let campaignsConcat = (ads || []).concat(campaigns || []);
    await campaignsConcat.sort(compare);
    return campaignsConcat;
  }
  if (allRequests.length === 1 && data?.type === "ads") {
    let adsCampaigns = allRequests[0].value;
    await adsCampaigns.sort(compare);
    return adsCampaigns;
  }
  if (allRequests.length === 1) {
    return allRequests[0].value;
  }
};

export const getCountCampaigns = async (): Promise<CountCampaigns[]> => {
  const response = await api.get(
    `/advertising-dashboard-${ENV}/goals/count/campaigns-this-week`,
    {}
  );

  return response.data?.content;
};

export const getInsightsSends = async (
  campaign_id: number | string,
  channel?: string
): Promise<InsightQueryWpResponse> => {
  const params = {
    idCampanha: campaign_id,
    channel,
  };

  const status = await api.get(
    `/insights-p2-${ENV}/${ENV}/crm/insights/getDesempenhoEnvio`,
    { params }
  );

  return status.data;
};

export const getClickRate = async (
  campaign_id: number | string
): Promise<any> => {
  const params = {
    idCampanha: campaign_id,
  };

  const { data } = await api.get(
    `/insights-p2-${ENV}/${ENV}/crm/getTaxaClique`,
    { params }
  );

  return data;
};

export const getInsightsAds = async (adsId: any, creativeId: any) => {
  const status = await api.get(
    `https://api.datasales.info/ads-manager-${ENV}/ads/insights/${adsId}/${creativeId}`,
    {
      params: {
        access_token:
          "EAALk5H3jEBoBALKjllI78aN93lLK82Jchg15HxJq1BSKHZBm4Os5cyQQ8Nf5k5OVRCsX3UniZA1jeTgZBqnDtCnXGZBacFXoWSB3MudV0vGw5eyzidRjJjJJmxeXFr0QFizZCOLo2HFufu7BqvAiBnaydF8HteEmWoRJKBjsZC4r8ybWPDF9qt",
      },
    }
  );

  return status.data;
};
